export default import.meta.ROLLDOWN_FILE_URL_tw6qxHJk3fzksdW6n_CvaA